import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import login from "../assets/Login/login.png";
import logo from "../assets/Login/aliklogo.png";

function Admin() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [authenticated, setAuthenticated] = useState(false);
    const navigate = useNavigate();

    const hardcodedUsername = "admin";
    const hardcodedPassword = "password";

    const handleLogin = (e) => {
        e.preventDefault();
        if (username === hardcodedUsername && password === hardcodedPassword) {
            setAuthenticated(true);
            navigate("/admin-dashboard");
        } else {
            alert("Invalid username or password");
        }
    };

    return (
        <div className="min-h-screen flex justify-center items-center bg-[#F7F7F7]">
            {authenticated ? null : (
                <div className="flex flex-row bg-white w-[100%] h-[100vh] sm:w-[100%] sm:h-[100vh] md:w-[80%] md:h-[80vh] lg:w-[80%] lg:h-[85vh]">
                    <div className="w-[50%] h-[100%] hidden lg:block">
                        <img
                            src={login}
                            alt="login"
                            className="rounded-l-[51px]"
                            style={{ height: "100%", width: "100%" }}
                        />
                    </div>
                    <div className="flex flex-col w-[100%] py-2 lg:py-4 lg:w-[50%] h-[100%] bg-[white] rounded-r-0 lg:rounded-r-[51px]">
                        <div className="flex justify-center items-center w-[100%] h-[10%] mt-16">
                            <div className="w-[40%] h-[100%]">
                                <img src={logo} alt="logo" style={{ height: "100%", width: "100%" }} />
                            </div>
                        </div>
                        <div className="flex justify-center items-center w-full h-[90%]">
                            <div className="flex flex-col items-center w-[75%] h-[80%] gap-9">
                                <div className="flex flex-col items-center">
                                    <span className="font-display text-[30px] sm:text-[40px] md:text-[50px] lg:text-[50px] xl:text-[50px] font-medium">
                                        Admin Login
                                    </span>
                                </div>
                                <div className="w-[100%] h-[13%]">
                                    <input
                                        placeholder="Username"
                                        className="w-[100%] h-[100%] bg-customGray rounded-[11px]"
                                        style={{ textIndent: "5%", fontFamily: "Josefin Sans, sans-serif" }}
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="w-[100%] h-[13%]">
                                    <input
                                        placeholder="Password"
                                        type="password"
                                        className="w-[100%] h-[100%] bg-customGray rounded-[11px]"
                                        style={{ textIndent: "5%", fontFamily: "Josefin Sans, sans-serif" }}
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                    />
                                </div>
                                <div
                                    className="w-[100%] h-[14%] rounded-[11px] bg-[#8B0000] font-display text-[24px] font-[600] text-[white] flex justify-center items-center cursor-pointer hover:bg-[#6d0000] transition-colors duration-300"
                                    onClick={handleLogin}
                                >
                                    Login
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Admin;